import React, { useState, useEffect } from "react";
import { BrandLogo } from "../../ui";

interface ScreenSizeCheckProps {
  children: React.ReactNode;
}

// Minimum usable width. The old gate also required height >= 700, which replaced
// the entire app on short windows/tablets (review §4.7); we drop the height check
// and lower the width so the app degrades gracefully instead of hard-blocking.
const MIN_WIDTH = 640;

/**
 * Renders the app at tablet/narrow widths and only shows a friendly, branded
 * message on very small (phone) widths, replacing the old unstyled hard wall.
 */
export function ScreenSizeCheck({ children }: ScreenSizeCheckProps) {
  const [isWideEnough, setIsWideEnough] = useState(
    typeof window === "undefined" || window.innerWidth >= MIN_WIDTH
  );

  useEffect(() => {
    const handleResize = () => setIsWideEnough(window.innerWidth >= MIN_WIDTH);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isWideEnough) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
        <BrandLogo className="h-6" />
        <p className="max-w-xs text-sm text-muted-foreground">
          The Composo platform is best on a tablet or larger screen. Please widen your window or
          switch to a larger device.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
